import React, { useState, useEffect, useRef } from 'react';
import JsonPreview from '../components/JsonPreview';
import Header from '../components/Header';
import MonacoJsonEditor from '../components/MonacoJsonEditor';
import Footer from '../components/Footer';
import { createSwapy } from 'swapy';

const BREAKPOINTS = {
  mobile: '@media (maxWidth: 768px)',
  tablet: '@media (maxWidth: 1024px)',
};

const JsonEditor = ({cookieConsent, setCookieConsent}) => {
  const [jsonInput, setJsonInput] = useState(localStorage.getItem('jsonInput') || '[]');

  const swapy = useRef(null);
  const container = useRef(null);

  useEffect(() => {
    localStorage.setItem('jsonInput', jsonInput);
  }, [jsonInput]);

  useEffect(() => {
    if (container.current) {
      swapy.current = createSwapy(container.current);
      swapy.current.onSwapEnd((e) => {
        setJsonInput(JSON.stringify(e.slotItemMap.asArray.map((item) => {
          return JSON.parse(item['item'].split('-')[0])
        }), null, 2));
        swapy.current.update();
      })
    }

    return () => {
      swapy.current?.destroy();
    };
  }, []);

  const styles = {
    container: {
      paddingBottom: "100px",
      paddingTop: "70px",
      minHeight: "100vh",
      position: "relative",
    },
    textareaContainer: {
      width: "90%",
      maxWidth: "1200px",
      margin: "0 auto",
      backgroundColor: "#fff",
      borderRadius: "20px",
      boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.3)",
      '@media (maxWidth: 768px)': {
        width: "95%",
        borderRadius: "10px",
      }
    },
    inputContainer: {
      flex: 1,
      backgroundColor: "#fff",
      borderRadius: "20px",
      padding: "20px",
    },
    editorContainer: {
      width: '100%',
      minHeight: '200px',
      maxHeight: '600px',
      borderRadius: '10px',
      overflow: 'hidden',
      boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.3)',
      [BREAKPOINTS.mobile]: {
        height: '70vh',
      },
    },
  };

  const handleJsonChange = (value) => {
    try {
      JSON.parse(value);
      setJsonInput(value);
    } catch (error) {
      // TODO: json format error, preview deleted bug
    }
  };

  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.textareaContainer}>
        <div style={styles.inputContainer}>
          <h2>JSON入力</h2>
          <div style={styles.editorContainer}>
            <MonacoJsonEditor
              val={jsonInput}
              onChange={handleJsonChange}
              disabled={cookieConsent !== 'accepted'}
              isBlock={false}
            />
          </div>
          <span style={{ marginTop: '40px', display: 'block' }}></span>
          <div ref={container}>
            <JsonPreview
              jsonInput={jsonInput}
              setJsonInput={setJsonInput}
              cookieConsent={cookieConsent}
            />
          </div>
        </div>
      </div>
      <Footer cookieConsent={cookieConsent} setCookieConsent={setCookieConsent} />
    </div>
  );
};

export default JsonEditor;
